export const faqList = [
    {
        question:
            'What does the “Weight” field represent?',
        answer: [
            'The weight defines how much impact or importance this goal has compared to other goals. It helps balance priorities when multiple goals are active.',
        ],
    },
    {
        question: 'Can I add multiple goals of the same type?',
        answer: [
            'No, only one active goal per type is allowed at a time. You can add multiple goals with the same type but previously added goals of that type must be made “Inactive”.',
        ],
    },
    {
        question:
            'What happens if I leave the Weight field blank?',
        answer: [
            'It is a mandatory field and the system will not allow you to save the goal; the field is mandatory and must have a valid numeric input.',
        ],
    },
    {
        question: 'Can I edit a goal after saving it?',
        answer: [
            'Yes, once saved, you can edit the goal later from the Market Configuration screen.',
        ],
    },
    {
        question: 'Why is the Save button disabled?',
        answer: [
            'The Save Goal button becomes active only when all required fields (marked with *) are filled with valid values.',
        ],
    },
    {
        question:
            'What does “Inactive” status mean?',
        answer: [
            'It means the goal exists in the system but is not currently influencing the NBA model’s results.',
        ],
    },
    {
        question:
            'How can I activate a goal?',
        answer: [
            'No we cannot activate a goal that is made inactive, the marketer should create another goal for the same objective.']
    },
    {
        question:
            'Why we cannot delete a goal?',
        answer: [
            'We cannot delete a goal, as to provide an audit trial and maintain history of the previous goals created.']
    }
];
